import classnames from "classnames";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import styles from "./buttonClick.module.css";

const ButtonClick = ({
  autoFocus,
  children, // e.g. for dynamic text rendering.
  className, // CSS class passthrough.
  disabled, // Bool passthrough for button disabling.
  icon, // FontAwesome icon name string.
  iconClassName,
  svgClassName,
  isActive, // Bool used to add active style to button.
  menuOpen, // Bool used to change style depending on the state of a menu (if there is one).
  onClick,
  primary, // Bool for primary styling.
  buttonRef, // React ref passthrough for button.
  role = "button",
  spin, // Bool to spin icon.
  style, // Raw js element style passthrough.
  text, // Text label for the button.
  textLink, // Bool, if true will have a text link style rather than a styled button.
  title, // Button title, shown on hover.
  type,
  ...rest
}) => {
  const buttonClassNames = classnames("mb-0", {
    [className]: Boolean(className),
    [styles.active]: isActive,
    [styles.button]: !textLink,
    [styles.link]: textLink,
    [styles.primary]: primary,
  });

  const chevronClassNames = classnames(styles.chevron, {
    [styles.rotate]: menuOpen,
    [svgClassName]: svgClassName,
  });

  return (
    <button
      autoFocus={autoFocus}
      className={buttonClassNames}
      disabled={disabled}
      onClick={onClick}
      ref={buttonRef}
      role={role}
      style={style}
      title={title}
      type={type}
      {...rest}
    >
      {icon && (
        <FontAwesomeIcon
          className={iconClassName ? iconClassName : styles.icon}
          icon={icon}
          fixedWidth
          spin={spin}
        />
      )}
      {children ? children : text || null}
      {!textLink && menuOpen !== undefined && (
        <FontAwesomeIcon className={chevronClassNames} icon={faChevronDown} />
      )}
    </button>
  );
};

ButtonClick.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.object,
  iconClassName: PropTypes.string,
  isActive: PropTypes.bool,
  menuOpen: PropTypes.bool,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  buttonRef: PropTypes.object,
  spin: PropTypes.bool,
  style: PropTypes.object,
  text: PropTypes.string,
  textLink: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
};

export default ButtonClick;
